import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { LoaderProvider } from "./context/LoaderContext";
import LoaderOverlay from "./component/items/Loader";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <LoaderProvider>
      <LoaderOverlay />
      <App />
    </LoaderProvider>
  </React.StrictMode>
);


reportWebVitals();
